import { SharedModule } from '../shared/shared.module';
import { StatsAndReportsLookupResolveService } from './shared/services/stats-and-reports-lookup-resolve.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StatsAndReportsRoutingModule } from './stats-and-reports-routing.module';
import { StatsAndReportsShellComponent } from './stats-and-reports-shell/stats-and-reports-shell.component';
import { StatsAndReportsAnnouncementsComponent } from './stats-and-reports-announcements/stats-and-reports-announcements.component';
import { StatsAndReportsListComponent } from './stats-and-reports-list/stats-and-reports-list.component';
import { StatsAndReportsService } from '@admin/stats-and-reports/shared/services/stats-and-reports.service';
import { StatsAndReportsJobseekersComponent } from './stats-and-reports-jobseekers/stats-and-reports-jobseekers.component';
import { StatsAndReportsCustomersComponent } from './stats-and-reports-customers/stats-and-reports-customers.component';
import { StatsAndReportsSubscribersComponent } from './stats-and-reports-subscribers/stats-and-reports-subscribers.component';
import { AnnouncementsTotalsPerCustomerComponent } from './announcements-totals-per-customer/announcements-totals-per-customer.component';
import { SalesReportComponent } from './sales-report/sales-report.component';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { SuspendedEmailsComponent } from './suspended-emails/suspended-emails.component';
import { CvDatabaseReportComponent } from './cv-database-report/cv-database-report.component';
import { MatchingAnnouncementsListComponent } from './matching-announcements-list/matching-announcements-list.component';
import { MatchingGenerateOnAnnouncementComponent } from './matching-generate-on-announcement/matching-generate-on-announcement.component';
import { ViewAnnouncementMatchingListComponent } from './view-announcement-matching-list/view-announcement-matching-list.component';
import { AnnouncementMatchingService } from './shared/services/announcement-matching.service';
import { JobseekersModule } from '@admin/jobseekers/jobseekers.module';
import { IndexationReportComponent } from './indexation-report/indexation-report.component';

@NgModule({
  imports: [
    CommonModule,
    StatsAndReportsRoutingModule,
    SharedModule,
    ChartModule,
    CheckboxModule,
    JobseekersModule,
  ],
  providers: [
    StatsAndReportsLookupResolveService,
    StatsAndReportsService,
    AnnouncementMatchingService,
  ],
  declarations: [
    StatsAndReportsShellComponent,
    StatsAndReportsAnnouncementsComponent,
    StatsAndReportsListComponent,
    StatsAndReportsJobseekersComponent,
    StatsAndReportsCustomersComponent,
    StatsAndReportsSubscribersComponent,
    AnnouncementsTotalsPerCustomerComponent,
    SalesReportComponent,
    SuspendedEmailsComponent,
    CvDatabaseReportComponent,
    MatchingAnnouncementsListComponent,
    MatchingGenerateOnAnnouncementComponent,
    ViewAnnouncementMatchingListComponent,
    IndexationReportComponent,
  ],
  exports: [SalesReportComponent],
})
export class StatsAndReportsModule {}
